import Swiper, { Navigation, Pagination, EffectFade, Keyboard, A11y, Autoplay } from 'swiper';
import Globals from './globals';
import HookManager from './hook-manager';

Swiper.use([Navigation, Pagination, EffectFade, Keyboard, A11y, Autoplay]);

// Filters:
//  * `wakefly/swiper_config` - Passes the default Swiper configuration object for modification

(function() {
  var wakefly = {
    carousel: {
      clear_swiper: (container) => {
        container = container || null;
        var targets = null;
        if (container == null) {
          targets = document.querySelectorAll('.swiper-container')
        } else {
          targets = [container];
        }
        targets.forEach((container) => {
          if (container.swiper) {
            var swiper_inst = container.swiper;
            swiper_inst.destroy();
          }
        })
      },
      initialize_swiper: (container, allowTouch = true) => {
        var parseBool = (val) => val == 'true';
        var config = {
          slidesPerView: 1,
          spaceBetween: container.getAttribute('data-carousel-spacebetween') != null ? parseInt(container.getAttribute('data-carousel-spacebetween')) : 20,
          centerInsufficientSlides: true,
          loop: parseBool(container.getAttribute('data-carousel-loop')),
          effect: container.getAttribute('data-carousel-effect'),
          speed: container.getAttribute('data-carousel-speed') != null ? parseInt(container.getAttribute('data-carousel-speed')) : 300,
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          watchOverflow: true,
          keyboard: true,
          scrollbar: false,
          allowTouchMove: allowTouch,
          on: {
            slidePrevTransitionStart: function() {
              var mindex = null;
              for (var key in this.slides) {
                var slide = this.slides[key];
                if (slide instanceof Element && slide.classList.contains('swiper-slide-visible')) {
                  mindex = Math.max(mindex === null ? parseInt(key) : mindex, parseInt(key))
                  slide.classList.add('swiper-slide-transitioning')
                }
              }
              if (mindex) {
                var leaving = this.slides[mindex + 1]
                if (leaving) {
                  leaving.classList.add('swiper-slide-transitioning')
                }
              }
            },
            slideNextTransitionStart: function() {
              var mindex = null;
              for (var key in this.slides) {
                var slide = this.slides[key];
                if (slide instanceof Element && slide.classList.contains('swiper-slide-visible')) {
                  mindex = Math.min(mindex === null ? parseInt(key) : mindex, parseInt(key));
                  slide.classList.add('swiper-slide-transitioning')
                }
              }
              if (mindex) {
                var leaving = this.slides[mindex - 1]
                if (leaving) {
                  leaving.classList.add('swiper-slide-transitioning')
                }
              }
            },
            slideChangeTransitionEnd: function() {
              for (var key in this.slides) {
                var slide = this.slides[key];
                if (slide instanceof Element && slide.classList.contains('swiper-slide-transitioning')) {
                  slide.classList.remove('swiper-slide-transitioning')
                }
              }
            }
          }
        };
        if (container.getAttribute('data-carousel-effect') == 'fade') {
          config.fadeEffect = {
            crossFade: true
          }
        }
        var spv = parseInt(container.getAttribute('data-carousel-slidesperview'));
        var breakpoints = {};
        switch (spv) {
          case 6:
            breakpoints[Globals.breakpoints.xl] = {
              slidesPerView: 6
            }
            breakpoints[Globals.breakpoints.lg] = {
              slidesPerView: 4
            }
            breakpoints[Globals.breakpoints.md] = {
              slidesPerView: 3
            }
            // always show at least two slides
            config.slidesPerView = 2;
            break;
          case 4:
            breakpoints[Globals.breakpoints.lg] = {
              slidesPerView: 4
            }
            breakpoints[Globals.breakpoints.md] = {
              slidesPerView: 3
            }
            breakpoints[Globals.breakpoints.xs] = {
              slidesPerView: 2
            }
            break;
          case 3:
            breakpoints[Globals.breakpoints.lg] = {
              slidesPerView: 3
            }
            breakpoints[Globals.breakpoints.sm] = {
              slidesPerView: 1
            }
            break;
          case 2:
            breakpoints[Globals.breakpoints.md] = {
              slidesPerView: 2
            };
            break;
          default:
            // do nothing
          break;
        }
        if (breakpoints) {
          config.breakpoints = breakpoints;
        }
        if (parseBool(container.getAttribute('data-carousel-pagination'))) {
          config.pagination = {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          }
        }
        if (parseBool(container.getAttribute('data-carousel-navigation'))) {
          config.navigation = {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
        var interval = parseInt(container.getAttribute('data-carousel-interval'));
        if (interval > 0) {
          config.autoplay = {
            delay: interval
          }
        }

        config = HookManager.do_filter('wakefly/swiper_config', config, container);
        var carousel = new Swiper(container, config);
        HookManager.invoke('wakefly/swiper_init', carousel, config, container);
        if (container.getAttribute('id')) {
          window.wf_carousel = window.wf_carousel || {};
          window.wf_carousel[container.getAttribute('id')] = carousel;
        }
      }
    }
  };

  // Set up page load initialization for front end display
  document.addEventListener('init-carousel', function() {
    wakefly.carousel.clear_swiper();
    document.querySelectorAll('.swiper-container').forEach((container) => {
      wakefly.carousel.initialize_swiper(container)
    })
  })

  document.addEventListener('readystatechange', function (evt) {
    if (document.readyState == 'complete') {
      document.dispatchEvent(new CustomEvent('init-carousel', {}))
    }
  })
})();
